import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TID } from "@/lib/testIds";
import TextReveal from "./TextReveal";

const QUOTES = [
  {
    quote:
      "The clarity MSMEmoney brought to our subsidy filing was unlike anything we had experienced with other consultants. They handled the department follow-ups end-to-end — sanction was in our account in months, not years.",
    name: "Mr. Rajesh Relhan",
    company: "Managing Director · Earth Industrial Park, Panipat",
    result: "₹12.5 Cr disbursed",
  },
  {
    quote:
      "We were staring at a ₹1.4 Cr delayed payment that could have killed our working capital. Their MSEFC filing was airtight and the counterparty settled before the first hearing itself.",
    name: "Founder",
    company: "Textile manufacturer, Panipat",
    result: "Full recovery + interest",
  },
  {
    quote:
      "From DPR to disbursement, they treated our project like it was their own factory. Rare to find advisors who understand both policy language and a promoter's balance sheet.",
    name: "Director",
    company: "Food processing unit, Sonipat",
    result: "₹1.25 Cr grant received",
  },
];

export const Testimonials = () => (
  <section
    id="testimonials"
    data-testid={TID.testimonials.root}
    className="relative bg-paper py-24 md:py-32 border-t border-navy/10 overflow-hidden"
  >
    <div aria-hidden className="absolute -top-40 right-1/4 h-[420px] w-[420px] rounded-full bg-[color:var(--violet)]/10 blur-[140px]" />
    <div aria-hidden className="absolute -bottom-40 left-10 h-[380px] w-[380px] rounded-full bg-[color:var(--gold)]/12 blur-[130px]" />

    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="grid grid-cols-12 gap-6 pb-14 md:pb-20 border-b border-navy/10">
        <div className="col-span-12 md:col-span-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-navy/60">
            07 — Voices from the field
          </p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <TextReveal as="h2" className="font-serif tracking-tight text-4xl md:text-6xl leading-[1.02] text-navy">
            What the shop-floor and the boardroom tell us.
          </TextReveal>
        </div>
      </div>

      <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {QUOTES.map((q, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ delay: i * 0.1, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="relative border border-navy/10 bg-white p-8 md:p-10 flex flex-col min-h-[380px]"
          >
            <Quote className="h-8 w-8 text-[color:var(--gold)]" strokeWidth={1.2} />
            <blockquote className="mt-6 font-serif text-[19px] md:text-[21px] leading-[1.4] text-navy tracking-tight">
              &ldquo;<TextReveal>{q.quote}</TextReveal>&rdquo;
            </blockquote>
            <figcaption className="mt-auto pt-8 border-t border-navy/10">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-navy font-medium">
                    {q.name}
                  </p>
                  <p className="mt-1.5 text-[14px] text-navy/85">
                    <TextReveal>{q.company}</TextReveal>
                  </p>
                </div>
                <span className="font-serif italic text-[color:var(--gold)] text-sm whitespace-nowrap font-semibold">
                  <TextReveal>{q.result}</TextReveal>
                </span>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
